import React, { useState } from "react";
import { StatusEnum } from "../../constants/employeeStatusEnum";
import { ThreeDots } from "react-loader-spinner";

const DeallocateShadowMember = ({
  memberForm,
  updateMember,
  closeMemberModal,
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isDeallocating, setIsDeallocating] = useState(false);
  const handleDeallocateConfirm = async () => {
    setIsDeallocating(true);
    try {
      const updatedMemberForm = {
        ...memberForm,
        status: { value: StatusEnum.DEALLOCATED, label: "Deallocated" },
      };
      const success = await updateMember(updatedMemberForm, false);
      if (success) {
        setShowConfirmModal(false);
        closeMemberModal();
      }
    } catch (error) {
      console.error("Deallocation failed.", error);
    } finally {
      setIsDeallocating(false);
    }
  };
  return (
    <>
      <button
        type="button"
        className="btn px-4 py-2"
        onClick={() => setShowConfirmModal(true)}
        style={{
          backgroundColor: "#d63737ff",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
        }}
        disabled={!memberForm.endDate}
      >
        Deallocate
      </button>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content rounded-lg">
              <div className="modal-body text-center">
                <h5>Are you sure you want to deallocate this member?</h5>
              </div>
              <div className="modal-footer justify-content-center">
                <button
                  type="button"
                  className={
                    isDeallocating ? "theme-button disabled" : "theme-button"
                  }
                  onClick={handleDeallocateConfirm}
                >
                  {isDeallocating ? (
                    <ThreeDots
                      height="20"
                      width="53"
                      radius="9"
                      color="white"
                      ariaLabel="loading"
                      visible={true}
                    />
                  ) : (
                    "Yes"
                  )}
                </button>
                <button
                  type="button"
                  className="theme-button bg-grey mx-3 w-35"
                  onClick={() => setShowConfirmModal(false)}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeallocateShadowMember;
